import React from 'react';
import { Link } from 'react-router-dom';
import { school, navLinks, programmes } from '../data/siteData';
import logo from '../assets/images/logo.webp';
import { FiPhone, FiMail, FiMapPin, FiArrowUp } from 'react-icons/fi';

const Footer = () => {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <>
      {/* Marquee */}
      <div style={{ background: 'var(--gold)', padding: '14px 0', overflow: 'hidden', whiteSpace: 'nowrap' }}>
        <div style={{ display: 'inline-block', animation: 'marquee 20s linear infinite' }}>
          {Array(6).fill('✦ Inspired by Finland ✦ Built for the World ✦ Play-Based Learning ✦ Admissions Open ').map((t, i) => (
            <span key={i} style={{ fontWeight: 700, color: 'var(--navy)', fontSize: '0.82rem', letterSpacing: '1px', marginRight: 24 }}>{t}</span>
          ))}
        </div>
      </div>

      <footer style={{ background: 'var(--navy)', padding: '70px 24px 30px', color: 'rgba(255,255,255,0.65)' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: '2.2fr 1fr 1fr 1.4fr', gap: 36 }} id="footer-grid">
            <div>
              <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 18 }}>
                <img src={logo} alt="" style={{ height: 52 }} />
                <div>
                  <div style={{ fontFamily: 'var(--fh)', fontWeight: 800, color: '#fff', fontSize: '1.1rem' }}>FINLAND</div>
                  <div style={{ fontSize: '0.55rem', color: 'var(--gold)', fontWeight: 700, letterSpacing: '2.5px' }}>EARLY YEARS</div>
                </div>
              </Link>
              <p style={{ fontSize: '0.88rem', lineHeight: 1.8, maxWidth: 280 }}>
                Bringing Finland's world-class early education philosophy to every child. Because happy children learn best.
              </p>
              {/* Newsletter */}
              <div style={{ marginTop: 24, display: 'flex', gap: 0 }}>
                <input placeholder="Your email" style={{
                  flex: 1, padding: '10px 14px', border: '1px solid rgba(255,255,255,0.15)',
                  borderRadius: '25px 0 0 25px', background: 'rgba(255,255,255,0.06)',
                  color: '#fff', fontSize: '0.82rem', outline: 'none',
                }} />
                <button style={{
                  padding: '10px 18px', background: 'var(--gold)', border: 'none',
                  borderRadius: '0 25px 25px 0', fontWeight: 700, color: 'var(--navy)',
                  fontSize: '0.78rem', cursor: 'pointer',
                }}>Subscribe</button>
              </div>
            </div>

            <div>
              <h4 style={{ color: 'var(--gold)', fontSize: '0.78rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: 18 }}>Quick Links</h4>
              {navLinks.map(l => (
                <Link key={l.path} to={l.path} style={{ display: 'block', marginBottom: 10, fontSize: '0.86rem', transition: 'color 0.3s' }}>{l.label}</Link>
              ))}
            </div>

            <div>
              <h4 style={{ color: 'var(--gold)', fontSize: '0.78rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: 18 }}>Programmes</h4>
              {programmes.map(p => (
                <Link key={p.id} to="/programmes" style={{ display: 'block', marginBottom: 10, fontSize: '0.86rem' }}>{p.name}</Link>
              ))}
            </div>

            <div>
              <h4 style={{ color: 'var(--gold)', fontSize: '0.78rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: 18 }}>Contact</h4>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14, fontSize: '0.86rem' }}><FiPhone size={14} color="var(--gold)" /> {school.phone}</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14, fontSize: '0.86rem' }}><FiMail size={14} color="var(--gold)" /> {school.email}</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20, fontSize: '0.86rem' }}><FiMapPin size={14} color="var(--gold)" /> {school.address}</div>
              <Link to="/contact" className="btn btn-outline" style={{ padding: '8px 22px', fontSize: '0.72rem', borderColor: 'rgba(255,255,255,0.2)' }}>Get Directions</Link>
            </div>
          </div>

          <div style={{ marginTop: 48, borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 22, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
            <span style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.3)' }}>
              © {new Date().getFullYear()} Finland Early Years. All rights reserved.
            </span>
            <button onClick={scrollTop} style={{
              background: 'rgba(255,255,255,0.08)', border: 'none', borderRadius: '50%',
              width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: 'pointer', color: 'var(--gold)', transition: 'background 0.3s',
            }}>
              <FiArrowUp size={16} />
            </button>
          </div>
        </div>

        <style>{`
          @media (max-width: 900px) { #footer-grid { grid-template-columns: 1fr 1fr !important; } }
          @media (max-width: 600px) { #footer-grid { grid-template-columns: 1fr !important; text-align: center; } }
        `}</style>
      </footer>
    </>
  );
};

export default Footer;
